<div class="search-container">
  <form class="form-search-bar" [formGroup]="searchForm" (ngSubmit)="handleSubmit()">

    <mat-form-field appearance="outline">
      <mat-label>Year</mat-label>
      <mat-select [formControl]="yearControl">
        <mat-option *ngFor="let year of years" [value]="year">{{year}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Order</mat-label>
      <mat-select [formControl]="orderControl">
<!--        <mat-option value="">{{"charts.filters.order.alphabetical" | translate}}</mat-option>-->
        <mat-option [value]="'asc'">{{"charts.filters.order.ascending" | translate}}</mat-option>
        <mat-option [value]="'desc'">{{"charts.filters.order.descending" | translate}}</mat-option>
      </mat-select>
    </mat-form-field>

    <button type="button" mat-raised-button (click)="clean()">Clean</button>
    <button type="submit" mat-raised-button color="primary">Apply</button>
    <app-zoom-help></app-zoom-help>
    <app-new-tab-button></app-new-tab-button>

  </form>
</div>
